import { PageInfo } from '../../share-types'

export interface IScheduledNotification {
  id: number
  subjectType: ScheduledNotificationSubjectTypeEnums
  subjectId: number
  recipientType: ScheduledNotificationRecipientTypeEnums
  recipientId: number
  notifyType: ScheduledNotificationTypeEnums
  sendTimeWindowStart: string
  sendTimeWindowEnd: string
  priority: ScheduledNotificationPriorityEnums
  status: ScheduledNotificationStatusEnums
  createdAt: string
  updatedAt: string
}

export type IPaginatedScheduledNotificationsParams = {
  page: number
  size: number
  subjectType: string
  subjectId: number
}

export type PaginatedScheduledNotificationsResponse = {
  pageInfo: PageInfo
  data: IScheduledNotification[]
}

export enum ScheduledNotificationSubjectTypeEnums {
  STUDIO = 'STUDIO',
  LESSON = 'LESSON',
  BOOKING = 'BOOKING',
  USER = 'USER',
  PLAN = 'PLAN',
  CREDITS_EXPIRATION = 'CREDITS_EXPIRATION',
  CREDIT_HISTORY = 'CREDIT_HISTORY',
  REFERRAL_HISTORY = 'REFERRAL_HISTORY',
  USER_COUPON = 'USER_COUPON',
  REFERRAL_REPEAT_PURCHASE_NUDGE = 'REFERRAL_REPEAT_PURCHASE_NUDGE',
  LESSON_SPOT_REQUEST = 'LESSON_SPOT_REQUEST',
  ORDER_HISTORY = 'ORDER_HISTORY',
  CORPORATE_CREDITS_DISTRIBUTION_SCHEDULE = 'CORPORATE_CREDITS_DISTRIBUTION_SCHEDULE',
}

export enum ScheduledNotificationRecipientTypeEnums {
  STUDIO = 'STUDIO',
  USER = 'USER',
  ADMIN = 'ADMIN',
  CORPORATE_CREDITS_DISTRIBUTION_SCHEDULE_HISTORY = 'CORPORATE_CREDITS_DISTRIBUTION_SCHEDULE_HISTORY',
}

export enum ScheduledNotificationTypeEnums {
  BOOKING_CANCELLATION = 'BOOKING_CANCELLATION',
  CONFIRMATION_CODE = 'CONFIRMATION_CODE',
  LESSON_START_REMINDER = 'LESSON_START_REMINDER',
  PURCHASE_SUCCESS = 'PURCHASE_SUCCESS',
  CREDITS_EXPIRATION_REMINDER_3_DAYS = 'CREDITS_EXPIRATION_REMINDER_3_DAYS',
  CREDITS_EXPIRATION_REMINDER_7_DAYS = 'CREDITS_EXPIRATION_REMINDER_7_DAYS',
  FROZEN_CREDITS_REACTIVATION_REMINDER_7_DAYS = 'FROZEN_CREDITS_REACTIVATION_REMINDER_7_DAYS',
  FROZEN_CREDITS_REACTIVATION_REMINDER_30_DAYS = 'CREDITS_EXPIRATION_REMINDER_30_DAYS',
  LESSON_SCHEDULE_UPDATE = 'LESSON_SCHEDULE_UPDATE',
  BOOKING_REMINDER = 'BOOKING_REMINDER',
  REFERRAL_SUCCESS = 'REFERRAL_SUCCESS',
  USER_COUPON_EXPIRATION = 'USER_COUPON_EXPIRATION',
  USER_CREATE_BOOKING = 'USER_CREATE_BOOKING',
  USER_CREATE_BOOKING_FAIL = 'USER_CREATE_BOOKING_FAIL',
  USER_CANCEL_BOOKING = 'USER_CANCEL_BOOKING',
  UPLOAD_LESSON_REMINDER = 'UPLOAD_LESSON_REMINDER',
  LESSON_UPDATES = 'LESSON_UPDATES',
  REFERRAL_REPEAT_PURCHASE_NUDGE = 'REFERRAL_REPEAT_PURCHASE_NUDGE',
  LESSON_SPOT_NOTIFICATION = 'LESSON_SPOT_NOTIFICATION',
  SPOT_REQUEST_FOLLOW_UP_REMINDER_NOTIFICATION = 'SPOT_REQUEST_FOLLOW_UP_NOTIFICATION',
  STUDIO_RESERVATION_REMINDER_1 = 'STUDIO_RESERVATION_REMINDER_1',
  STUDIO_RESERVATION_REMINDER_2 = 'STUDIO_RESERVATION_REMINDER_2',
  STUDIO_RESERVATION_REMINDER_3 = 'STUDIO_RESERVATION_REMINDER_3 ',
  STUDIO_SUBSCRIPTION_REMINDER = 'STUDIO_SUBSCRIPTION_REMINDER',
  COUPON_RECEIVED = 'COUPON_RECEIVED',
  COUPON_RECEIVED_BEFORE_CREDITS_EXPIRED = 'COUPON_RECEIVED_BEFORE_EXPIRED',
  IKEA_USER_FIRST_BOOKING_COMPLETION = 'IKEA_USER_FIRST_BOOKING_COMPLETION',
  IKEA_USER_VIEW_RESTRICTED = 'IKEA_USER_VIEW_RESTRICTED',
  CART_ABANDON_REMINDER = 'CART_ABANDON_REMINDER',
  REPURCHASE_COUPON_ISSUED = 'REPURCHASE_COUPON_ISSUED',
  CORPORATE_DISTRIBUTE_CREDITS = 'CORPORATE_DISTRIBUTE_CREDITS',
}

export enum ScheduledNotificationStatusEnums {
  PENDING = 'PENDING',
  QUEUED = 'QUEUED',
  SENDING = 'SENDING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export enum ScheduledNotificationPriorityEnums {
  LOW = 'LOW',
  MIDDLE = 'MIDDLE',
  HIGH = 'HIGH',
}
